import React from 'react';

//components
import ModalWrapper from '../../../ModalWrapper'
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';

//styling
import "../../../../../css/orgSettings/userGroups/RemoveFromWorkspaceModalModal.scss"



const RemoveFromWorkspaceModal = ({showModal, onRemoveClick, onCloseClick, groupname, workspaceName} : {showModal: boolean, onRemoveClick: any, onCloseClick: any, groupname: string, workspaceName: string}) => {

    return (
        <ModalWrapper isOpen={showModal} onRequestClose={onCloseClick} className="remove-group-modal" children={
            <div className="remove-group-modal-content">
                <h1 className="header">Remove Workspace Access</h1>

                <span className="sub-title">{`Are you sure you want to remove ${groupname} from ${workspaceName}`}</span>

                <div className='buttons-panel'>
                    <BasicButton content={"Cancel"}  className={"cancel-button"}  ariaLabel={"Keep existing permissions and close modal"} onButtonClick={onCloseClick} />
                    <BasicButton content={"Remove"}  className={"remove-button"}  ariaLabel={"Remove group from workspace"} onButtonClick={onRemoveClick} />
                </div>
            </div>
        }/>
    );  
}

export default RemoveFromWorkspaceModal;